import React, { Component } from "react";
import styled from "styled-components";
import Card from "../components/Card";
import PostedJobItem from "../components/PostedJobItem";
import { Link } from "react-router-dom";
import { db } from "../config";
import moment from "moment";
import loader from "../Ellipsis-1s-200px.svg";

// Admin level component: enrty point to admin
// only the custom created user can create new users

const NumberMetricStyle = styled.div`
  background-color: #7c4dff;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  h3 {
    font-weight: 500;
    font-size: 1.5rem;
    font-family: "Montserrat", sans-serif;
  }
`;
const NumberMetric = props => (
  <NumberMetricStyle className="pointer">
    <h3 className="white">{props.title}</h3>
    <h3 className="pink">{props.rate || 0}</h3>
  </NumberMetricStyle>
);

const Metrics = props => (
  <div className="columns is-multiline">
    <div className="column is-3">
      <NumberMetric rate={props.jobs.length} title="Jobs Posted" />
    </div>
    <div className="column is-3">
      <NumberMetric rate={props.totalApplicants} title="Total Applicants" />
    </div>
  </div>
);

class Office extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      totalApplicants: 0 
    };
  }

  getTotalApplicants() {
    // run after posted jobs have been fetched
    this.state.jobs.forEach(job => {
      db.collection(job.id)
        .get()
        .then(querySnapshot => {
          this.setState({
            totalApplicants: this.state.totalApplicants + querySnapshot.size
          })
        })
    })
  }

  componentDidMount() {
    this.setState({ loading: true });
    db
      .collection("jobs")
      .get()
      .then(querySnapshot => {
        let jobs = [];
        querySnapshot.forEach(doc => {
          jobs.push(doc.data());
        });
        this.setState({ jobs });
      })
      .then(() => this.getTotalApplicants())
      .then(() => this.setState({ loading: false }))
      .catch(err => {
        this.setState({ error: err, loading: false });
      });
  }

  render() {
    const { jobs, loading } = this.state;
    console.log(this.state.totalApplicants)
    return (
      <div className="pa3 ph5-l mh4-l pt4 pb6" style={{ minHeight: 350 }}>
        <Metrics jobs={jobs} totalApplicants={this.state.totalApplicants} />
        <h1 className="f4 fw5 mt5 mb2">Posted Jobs</h1>
        <div className="columns is-multiline">
          {!loading ? null : (
            <div className="mt3 ml3">
              <img src={loader} height="40" width="40" alt="" />
            </div>
          )}

          {jobs && jobs.length
            ? jobs.map((x, i) => (
                <div key={i} className="column is-4">
                  <Link to={`/office/job/${x.id}`}>
                    <Card style={{ background: "#fff" }}>
                      <PostedJobItem
                        jobTitle={x.title}
                        id={x.id}
                        createdAt={moment(x.createdAt).format("L")}
                        closingDate={x.closingDate}
                      />
                    </Card>
                  </Link>
                </div>
              ))
            : null}
        </div>
      </div>
    );
  }
}

export default Office;



// WEBPACK FOOTER //
// ./src/pages/office.js